<template>
  <IonContent class="ion-no-padding" :scroll-events="true" @ion-scroll="onScroll">
    <IonRefresher slot="fixed" @ion-refresh="handleRefresh">
      <IonRefresherContent />
    </IonRefresher>

    <PageContentWrapperCompact>
      <ContractsView @open-modal="openCreateModal" />
    </PageContentWrapperCompact>

    <FloatingActionButton
      slot="fixed"
      class="fixed right-4 md:hidden"
      rounded
      @click="openCreateModal"
    />
  </IonContent>

  <CreateContractModal
    :show="showCreateModal"
    @close="showCreateModal = false"
  />
</template>

<script setup lang="ts">
import { ref, provide } from 'vue';
import FloatingActionButton from '@/application/components/FloatingAction/FloatingActionButton.vue';
import CreateContractModal from '@/contracts/components/CreateContractModal.vue';
import ContractsView from "@/contracts/components/ContractsView.vue";
import PageContentWrapperCompact from "@/application/layouts/ContentWrapper/PageContentWrapperCompact.vue";
import { useAiDocumentExtractionStore } from '@/documents/store/aiDocumentExtractionStore.ts';
import {
  IonContent,
  IonRefresher,
  IonRefresherContent,
  type RefresherEventDetail,
  type ScrollCustomEvent
} from '@ionic/vue';
import { useContractStore } from '@/contracts/stores/contractStore.ts';

const showCreateModal = ref(false);
const isScrolled = ref(false)

const { fetchExtractionAvailabilityStatus } = useAiDocumentExtractionStore();

function openCreateModal() {
  fetchExtractionAvailabilityStatus();
  showCreateModal.value = true;
}

async function handleRefresh(event: CustomEvent<RefresherEventDetail>) {
  try {
    await useContractStore().fetchContractsAndDepots(true);
  } finally {
    event.detail.complete();
  }
}

const onScroll = (event: ScrollCustomEvent) => {
  isScrolled.value = event.detail.scrollTop > 0
}

provide('isScrolled', isScrolled)
</script>
